import { IPoderCalorifico } from '../../core/interfaces/calorific-power.interface';

export class GetAllCalorificPowerAction {
  static readonly type = '[CalorificPower] Get All';
  constructor() {}
}

export class AddCalorificPowerAction {
  static readonly type = '[CalorificPower] Add New Calorific Power';
  constructor(public payload: IPoderCalorifico) {}
}

export class UpdatedCalorificPowerAction {
  static readonly type = '[CalorificPower] Updated Calorific Power';
  constructor(public payload: IPoderCalorifico) {}
}

export class DeleteCalorificPowerAction {
  static readonly type = '[CalorificPower] Delete';
  constructor(public payload: string) {}
}

